import { CheckMarkIcon } from '../../assets/icons';
import styles from './style.module.scss';

interface Props {
    title: string;
    removeFunc?: any;
};

export default function Chips(props: Props) {
    const { title, removeFunc } = props;

    return (
        <div className={styles.wrapper}>
            <CheckMarkIcon fill='#95E6ED' />
            <span className={styles.title}>{title}</span>
            {removeFunc && <span className={styles.remove} onClick={removeFunc}>&times;</span>}
        </div>
    );
};
